import { useState, useEffect } from "react";
import api from "@/lib/api";
import { Search, Loader2 } from "lucide-react";

export default function Scanner() {
  const [text, setText] = useState("");
  const [findings, setFindings] = useState(null);
  const [terms, setTerms] = useState([]);
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get("/blocked-terms").then((r) => setTerms(r.data.terms || [])); }, []);

  const run = async () => {
    if (!text.trim()) return;
    setBusy(true);
    try {
      const { data } = await api.post("/admin/scan", { text });
      setFindings(data.findings || []);
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-screen-2xl mx-auto px-6 py-10">
      <div className="label-eyebrow">Compliance</div>
      <h1 className="text-2xl font-bold tracking-tight mt-1">Blocked-claims scanner</h1>
      <p className="text-sm text-[#5E636E] mt-2">Paste any product, article, support reply, or marketing copy. The scanner will return word-boundary matches against the maintained blocklist.</p>

      <div className="mt-8 grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 space-y-4">
          <textarea value={text} onChange={(e) => setText(e.target.value)} rows={12} placeholder="Paste content to scan…" className="w-full p-3 border border-[#D1D5DB] font-mono text-sm" data-testid="scanner-input" />
          <button onClick={run} disabled={busy} className="btn-primary inline-flex items-center gap-2" data-testid="scanner-run">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Search className="h-4 w-4" />}
            Scan content
          </button>

          {findings !== null && (
            <div className="border border-[#D1D5DB]">
              <div className="px-4 py-3 border-b border-[#D1D5DB] bg-[#F7F7F8] flex items-center justify-between">
                <div className="label-eyebrow">Result</div>
                <div className="font-mono text-xs">{findings.length} match{findings.length !== 1 ? "es" : ""}</div>
              </div>
              {findings.length === 0 ? (
                <div className="px-4 py-6 text-center font-mono text-xs text-[#0B6623] uppercase tracking-wider">CLEAR · No blocked terms detected</div>
              ) : (
                <ul className="divide-y divide-[#EAEBEF]">
                  {findings.map((f, i) => (
                    <li key={i} className="px-4 py-3 text-sm">
                      <span className="bg-[#D0021B] text-white px-1.5 py-0.5 font-mono text-[11px] uppercase tracking-wider">{f.term}</span>
                      <span className="ml-2 text-[#5E636E] font-mono text-xs">…{f.context}…</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}
        </div>

        <aside className="border border-[#D1D5DB] bg-[#F7F7F8] p-5">
          <div className="label-eyebrow mb-3">Blocklist ({terms.length})</div>
          <div className="flex flex-wrap gap-1.5 max-h-[480px] overflow-y-auto">
            {terms.map((t) => <span key={t} className="font-mono text-[11px] bg-white border border-[#D1D5DB] px-2 py-0.5">{t}</span>)}
          </div>
        </aside>
      </div>
    </div>
  );
}
